// extracted by mini-css-extract-plugin
export default {"btn":"styles_btn__heVIG","text":"styles_text__+sNfO"};